import '@i18n/config';
import '@features/auth';

import { ReduxProvider } from '@app/providers/ReduxProvider';
import { ThemeProvider } from '@app/providers/ThemeProvider';
import { router } from '@app/routes/routes';
import { AuthBootstrap } from '@features/auth/AuthBootstrap';
import { installApiErrorNotifier } from '@services/api/apiErrorNotifier';
import { getReporter, installWebVitals } from '@services/monitoring';
import { FullPageProgress } from '@shared/components/feedback/FullPageProgress';
import { RootErrorBoundary } from '@shared/components/feedback/RootErrorBoundary';
import { ConfirmProvider } from '@shared/confirm';
import { NotificationsProvider } from '@shared/notifications';
import { ServiceWorkerUpdate } from '@shared/pwa/ServiceWorkerUpdate';
import { RouterProvider } from 'react-router-dom';

installApiErrorNotifier();
installWebVitals();

export default function App() {
  return (
    <RootErrorBoundary
      onError={(error, info) => {
        getReporter().captureError(error, { componentStack: info.componentStack });
      }}
    >
      <ReduxProvider>
        <ThemeProvider>
          <NotificationsProvider>
            <ConfirmProvider>
              <AuthBootstrap fallback={<FullPageProgress />}>
                <ServiceWorkerUpdate />
                <RouterProvider router={router} />
              </AuthBootstrap>
            </ConfirmProvider>
          </NotificationsProvider>
        </ThemeProvider>
      </ReduxProvider>
    </RootErrorBoundary>
  );
}
